import { prefixLanguage } from '@sub/src/utils/urls'
import { BASE_URL } from '@/router/consts'

const p = (postfix: string) => prefixLanguage(`${BASE_URL}${postfix}/`)

export const STAFF_DOCUMENTS = p('staff/documents')
export const STAFF_DOCUMENTS_DETAIL = p('staff/documents/detail/:docId')

export const STAFF_BSNS_ACTS = p('staff/acts')
